// Module
var code = `<div class="js-quantity-position-sizing-btn {{#checked}}checked{{/checked}} {{#focused}}focused{{/focused}} {{#if hasError}}error{{/if}} {{^.positionSizingEnabled}}disabled{{/}}"
     as-tooltip="tooltip"
     on-mousedown="@this.onClick(event)">
    <svg>
        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#positionSizeBtn"></use>
    </svg>
</div>`;
// Exports
export default code;